/** Monedas en que puede operar una empresa (debe coincidir con CURRENCIES del backend). */
export const CURRENCY_OPTIONS = [
  { value: 'COP', label: 'Peso colombiano (COP)' },
  { value: 'USD', label: 'Dólar estadounidense (USD)' },
] as const;
export type CurrencyCode = (typeof CURRENCY_OPTIONS)[number]['value'];
